import loadable from "@loadable/component";

export * from "./Button";
export const Breadcrumb = loadable(() => import("./Breadcrumb/index"));
export const AuthLogo = loadable(() => import("./AuthLogo/index"));
export const TabComponent = loadable(() => import("./Tabs/index"));
export const GlobalLoader = loadable(() => import("./GlobalLoader/index"));
export const FileUploader = loadable(() => import("./FileUploader/index"));
export const Charts = loadable(() => import("./Chart/index"));
export const ModalComponent = loadable(() => import("./Modal/Index"));
export const DataTable = loadable(() => import("./DataTable/index"));
export const Pagination = loadable(() => import("./Pagination/index"));
export const ActionDropdown = loadable(() => import("./ActionDropdown/index"));
export const SweetAlert = loadable(() => import("./SweetAlert/index"));
export const TextEditor = loadable(() => import("./TextEditor/index"));
export const ImageElement = loadable(() => import("./ImageElement/index"));
export const RippleEffect = loadable(() => import("./RippleEffect/index"));

export const UserHeader = loadable(() => import("./Header/index"));
export const UserFooter = loadable(() => import("./Footer/index"));

export const AcountSidebar = loadable(() => import("./AcountSidebar/index"));
export const AccordionComponent = loadable(() =>
  import("./AccordionComponent/index")
);

export const HeaderDropdown = loadable(() => import("./HeaderDropdown/index"));
export const LinkComponent = loadable(() => import("./LinkComponent/index"));
export const NoDataFound = loadable(() => import("./NoDataFound/index"));
export const LoginHeader = loadable(() => import("./LoginHeader/index"));

export const InnerFooter = loadable(() => import("./InnerPagesFooter/index"));

// Family Tree
export const FamilyTree = loadable(() => import("./FamilyTree/index"));
export const FamilyTreeThemeOne = loadable(() =>
  import("./FamilyTreeThemeOne/index")
);
export const FamilyTreeThemeTwo = loadable(() =>
  import("./FamilyTreeThemeTwo/index")
);
export const FamilyTreeThemeThree = loadable(() =>
  import("./FamilyTreeThemeThree/index")
);
export const FamilyTreeThemeFour = loadable(() =>
  import("./FamilyTreeThemeFour/index")
);
export const ViewMemories = loadable(() => import("./ViewMemories/index"));
export const UserTabComponent = loadable(() =>
  import("./UserTabComponent/index")
);
export const SubscriptionTab = loadable(() =>
  import("./SubscriptionTab/index")
);
export const SubscribeCard = loadable(() => {
  import("./SubscriptionTab/subscribeCard");
});
export const SubscriptionPlanCard = loadable(() =>
  import("./SubscriptionTab/subscriptionPlanCard")
);
export * from "./NewsHeadlines/index";
export const ThemeComponnent = loadable(() => import("./ThemeComponent/index"));
export { default as RadioGroup } from "./RadioGroup";
export const MultipleInput = loadable(() => import("./MultipleInput/index"));
export const TimelineComponent = loadable(() =>
  import("./TimelineComponent/index")
);
export const ThemeNavbar = loadable(() => import("./ThemeNavbar/index"));
export const SliderComponent = loadable(() =>
  import("./SliderComponent/index")
);
export const CapturedCard = loadable(() => import("./capturedCard/index"));
export const StepSixTable = loadable(() => import("./StepSixTable/index"));
export const StepFiveTable = loadable(() => import("./StepFiveTable/index"));
export * from "./Theme01";
export const AutocompleteDebounce = loadable(() =>
  import("./AutocompleteDebounce/index")
);
export const VideoElement = loadable(() => import("./VideoElement/index"));
export const ReactGoogleMap = loadable(() => import("./GoogleMap/index"));
export const AudioElement = loadable(() => import("./AudioElement/index"));
export * from "./Theme04";
export const TimelineModal = loadable(() => import("./TimelineModal/index"));
export * from "./Static";
export * from "./Theme03";
export const ThemeTwoNavBar = loadable(() => import("./ThemeTwoNavBar/index"));
export const WebShare = loadable(() => import("./Share/index"));
export const AudioWaveform = loadable(() => import("./AudioWave/index"));
export const SavedCardComponent = loadable(() => import("./SavedCard/index"));
export const TransactionHistory = loadable(() => import("./Transaction/index"));
export const Header = loadable(() => import("./Header/index"));
export const SearchByLocationModal = loadable(() =>
  import("./SearchByLocationModal/index")
);
export const AlbumModal = loadable(() => import("./AlbumModel/index"));
export { default as AuthDesign } from "./AuthDesign/index";
